import { Facebook, Instagram } from "lucide-react";

// TikTok icon component since it's not available in lucide-react
const TikTokIcon = ({ className }: { className?: string }) => (
  <svg 
    className={className} 
    viewBox="0 0 24 24" 
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

export function Footer() {
  return (
    <footer className="bg-foreground text-background py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between gap-8 md:gap-12">
          <div className="flex-1 space-y-4 text-center">
            <h3 className="text-2xl text-primary-foreground">YOGIVITY</h3>
            <p className="text-sm text-background/80">
              Aktív, fitt életre vágyó 40 év feletti nőknek segítek visszaszerezni és megőrizni vitalitásukat, legjobb formájukat, életörömüket és magabiztosságukat egyszerű és fenntartható Yogivity – életmód és jóga – programommal.
            </p>
          </div>
          
          <div className="flex-1 space-y-4 text-center">
            <h4 className="text-background">Gyors linkek</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#home" className="text-background/80 hover:text-background transition-colors">Kezdőlap</a></li>
              <li><a href="#services" className="text-background/80 hover:text-background transition-colors">Szolgáltatásaim</a></li>
              <li><a href="#about" className="text-background/80 hover:text-background transition-colors">Rólam</a></li>
              <li><a href="#contact" className="text-background/80 hover:text-background transition-colors">Kapcsolat</a></li>
            </ul>
          </div>
          
          <div className="flex-1 space-y-4 text-center">
            <h4 className="text-background">Szolgáltatások</h4>
            <ul className="space-y-2 text-sm">
              <li><span className="text-background/80 cursor-pointer hover:text-background transition-colors" onClick={() => document.getElementById('yogivity-program')?.scrollIntoView({ behavior: 'smooth' })}>YOGIVITY Program</span></li>
              <li><span className="text-background/80 cursor-pointer hover:text-background transition-colors" onClick={() => document.getElementById('etkezes-tanacsadas')?.scrollIntoView({ behavior: 'smooth' })}>Étkezési Tanácsadás</span></li>
              <li><span className="text-background/80 cursor-pointer hover:text-background transition-colors" onClick={() => document.getElementById('jogazz-online')?.scrollIntoView({ behavior: 'smooth' })}>Jógázz Online</span></li>
            </ul>
          </div>
          
          <div className="flex-1 space-y-4 text-center">
            <h4 className="text-background">Kövess itt</h4>
            <div className="flex space-x-4 justify-center">
              <a href="https://www.facebook.com/people/Yogivity-Újra-önmagam-40-felett/61577407109967/" rel="noreferrer" target="_blank" className="text-background/80 hover:text-background transition-colors">
                <Facebook className="w-6 h-6" />
              </a>
              <a href="https://www.instagram.com/yogivity_dorkaval/" rel="noreferrer" target="_blank" className="text-background/80 hover:text-background transition-colors">
                <Instagram className="w-6 h-6" />
              </a>
              <a href="https://www.tiktok.com/@yogivity_dorkaval" rel="noreferrer" target="_blank" className="text-background/80 hover:text-background transition-colors">
                <TikTokIcon className="w-6 h-6" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-200 mt-12 pt-8">
          <div className="text-center space-y-2">
            <p className="text-sm text-gray-400">
              © Copyright Berekvölgyi Dorottya - Minden jog fenntartva
            </p>
             <div className="flex justify-center space-x-6 text-sm">
               <a href="/adatvedelmi.pdf" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-gray-700 transition-colors">
                 Adatkezelési tájékoztató
               </a>
             </div>
          </div>
        </div>
      </div>
    </footer>
  );
}